export default __webpack_public_path__ + "static/hold-cb7e0832b5e5e9a379a246b118b1cc57.png";